import React from 'react'
import {Form, Row, Col} from 'react-bootstrap'

interface CallTypeSelectorProps {
  selectedType: 'audio' | 'video' | 'ai-interpretation'
  onTypeChange: (type: 'audio' | 'video' | 'ai-interpretation') => void
  videoDisabled?: boolean
  aiInterpretationVisible?: boolean
  aiInterpretationEnabled?: boolean
  aiInterpretationDisabledTooltip?: string
  standardCallEnabled?: boolean
}

const CallTypeSelector: React.FC<CallTypeSelectorProps> = ({
  selectedType,
  onTypeChange,
  videoDisabled = false,
  aiInterpretationVisible = false,
  aiInterpretationEnabled = false,
  aiInterpretationDisabledTooltip = '',
  standardCallEnabled = true,
}) => {
  const visibleOptionCount =
    (standardCallEnabled ? 1 : 0) +
    (standardCallEnabled && !videoDisabled ? 1 : 0) +
    (aiInterpretationVisible ? 1 : 0)
  const columnSize = visibleOptionCount >= 3 ? 4 : visibleOptionCount === 1 ? 12 : 6

  return (
    <div>
      <Form.Label className='fw-bold mb-3 d-block'>Call Type</Form.Label>
      <Row className='g-3'>
        {standardCallEnabled && (
        <Col xs={12} sm={columnSize}>
          <div
            className={`
              p-3 border rounded cursor-pointer transition-all
              ${
                selectedType === 'audio'
                  ? 'border-primary bg-primary bg-opacity-10 shadow-sm'
                  : 'border-light bg-light hover-shadow'
              }
            `}
            onClick={() => onTypeChange('audio')}
            style={{cursor: 'pointer'}}
          >
            <Form.Check
              type='radio'
              id='audio-call'
              name='callType'
              checked={selectedType === 'audio'}
              onChange={() => onTypeChange('audio')}
              className='d-none'
            />
            <div className='d-flex align-items-center justify-content-center text-center'>
              <div>
                <i
                  className={`bi bi-telephone fs-2 mb-2 d-block ${
                    selectedType === 'audio' ? 'text-primary' : 'text-muted'
                  }`}
                ></i>
                <span
                  className={`fw-semibold ${
                    selectedType === 'audio' ? 'text-primary' : 'text-dark'
                  }`}
                >
                  Audio Call
                </span>
              </div>
            </div>
          </div>
        </Col>
        )}
        {standardCallEnabled && !videoDisabled && (
        <Col xs={12} sm={columnSize}>
            <div
              className={`
                p-3 border rounded cursor-pointer transition-all
                ${
                  selectedType === 'video'
                    ? 'border-primary bg-primary bg-opacity-10 shadow-sm'
                    : 'border-light bg-light hover-shadow'
                }
              `}
              onClick={() => onTypeChange('video')}
              style={{cursor: 'pointer'}}
            >
              <Form.Check
                type='radio'
                id='video-call'
                name='callType'
                checked={selectedType === 'video'}
                onChange={() => onTypeChange('video')}
                className='d-none'
              />
              <div className='d-flex align-items-center justify-content-center text-center'>
                <div>
                  <i
                    className={`bi bi-camera-video fs-2 mb-2 d-block ${
                      selectedType === 'video' ? 'text-primary' : 'text-muted'
                    }`}
                  ></i>
                  <span
                    className={`fw-semibold ${
                      selectedType === 'video' ? 'text-primary' : 'text-dark'
                    }`}
                  >
                    Video Call
                  </span>
                </div>
              </div>
            </div>
          </Col>
        )}
        {aiInterpretationVisible && (
          <Col xs={12} sm={columnSize}>
            <div
              className={`
                p-3 border rounded cursor-pointer transition-all
                ${
                  selectedType === 'ai-interpretation'
                    ? 'border-primary bg-primary bg-opacity-10 shadow-sm'
                    : 'border-light bg-light'
                }
                ${aiInterpretationEnabled ? 'hover-shadow' : 'opacity-75'}
              `}
              onClick={() => aiInterpretationEnabled && onTypeChange('ai-interpretation')}
              style={{cursor: aiInterpretationEnabled ? 'pointer' : 'not-allowed'}}
              title={!aiInterpretationEnabled ? aiInterpretationDisabledTooltip : undefined}
            >
              <Form.Check
                type='radio'
                id='ai-interpretation-call'
                name='callType'
                checked={selectedType === 'ai-interpretation'}
                onChange={() => onTypeChange('ai-interpretation')}
                disabled={!aiInterpretationEnabled}
                className='d-none'
              />
              <div className='d-flex align-items-center justify-content-center text-center'>
                <div>
                  <i
                    className={`bi bi-stars fs-2 mb-2 d-block ${
                      selectedType === 'ai-interpretation' ? 'text-primary' : 'text-muted'
                    }`}
                  ></i>
                  <span
                    className={`fw-semibold ${
                      selectedType === 'ai-interpretation' ? 'text-primary' : 'text-dark'
                    }`}
                  >
                    AI Interpretation
                  </span>
                </div>
              </div>
            </div>
          </Col>
        )}
      </Row>
    </div>
  )
}

export default CallTypeSelector
